import { useContext } from 'react';
import BioContext from '../../store/bio-context';
const SocialMedia = () => {
    const profileInfo = useContext(BioContext);
    const socialMedia = [...profileInfo.SocialMedia];
    return ( 
        <div className="social-media">
            {socialMedia && socialMedia.map(handle=>(
                <div key={handle.id}>
                    {handle.icon && <img src={handle.icon} onClick={()=> window.open(`${handle.URL}`,'_blank')} alt={handle.platform} height="40" width="40" />}
               </div> 
            ))}
        </div>
     );
}
 
export default SocialMedia;